import { FunctionComponent } from 'react'
import { Typography } from '@black-bear-energy/rucksack'

export const FieldLabel: FunctionComponent<FieldLabelProps> = ({
  label,
  variant = 'subtitle2',
}) => {
  return <Typography variant={variant}>{label}</Typography>
}

interface FieldLabelProps {
  label: string
  variant?: 'subtitle2'
}
